module.exports = __webpack_public_path__ + "static/media/IMG_3404-min.dc0c044e.JPG";